import { render } from "./AboutTab.vue?vue&type=template&id=32414340&scoped=true"
import script from "./AboutTab.vue?vue&type=script&lang=js"
export * from "./AboutTab.vue?vue&type=script&lang=js"

import "./AboutTab.vue?vue&type=style&index=0&id=32414340&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32414340"]])

export default __exports__